import { createFileRoute } from "@tanstack/react-router";
import { BookEditPage } from "@/components/catalog/book-edit";

export const Route = createFileRoute("/_app/books/$id/edit")({
  component: BookEditRoute,
});

function BookEditRoute() {
  const { id } = Route.useParams();
  return <BookEditPage bookId={id} />;
}
